import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function About() {
    return(
        <Container>
            <Row>
                <Col sm={12} md={4}>
                    <Image roundedCircle className="profile" src="profile.jpg" id="about" alt="Ville's profile picture" />
                </Col>
                <Col sm={12} md={8}>
                    <h1>Ville Kuosmanen</h1>
                    <p><i>Founder and CEO of Safe Robotics</i></p>
                    <p><i>[ more to come ]</i></p>
                </Col>
            </Row>
            </Container>
    );
}

export default About;